(function() {
    'use strict';

    angular
        .module('pwc.model')
        .service('Region', Region);

    Region.$inject = ['$window', 'BaseModel', 'Slug', 'lodash', '$log'];

    function Region($window, BaseModel, Slug, lodash, $log) {

        // Entity Defaults
        var defaults = $window.stampit().state({
            "name": null
        });

        // attach methods to entity
        var RegionFactory = $window.stampit().enclose(function () {

            this.getFullName = function(){
                if (lodash.isEmpty(this.name)){
                    return null;
                }
                var pieces = [this.name];

                if (! lodash.isEmpty(this.parent)){
                    pieces.push(this.parent.name);
                }

                if (! lodash.isEmpty(this.country)){
                    pieces.push(this.country);
                }

                return pieces.join(' > ');
            };

            return $window.stampit.mixIn(this, BaseModel);
        });

        return function (properties){
            return $window.stampit.compose(defaults, RegionFactory).create(properties);
        };

    }

})();